import React, {FC} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {Link} from 'react-router-dom'
import {formatTime, ICalendarOccurrence, recurrenceSummary, TYPE_LABEL} from './CalendarModel'

type Props = {
  occurrence: ICalendarOccurrence | null
  interviewPath: string
  onClose: () => void
  onEdit: (occurrence: ICalendarOccurrence) => void
  onDeleteOccurrence: (occurrence: ICalendarOccurrence) => void
  onDeleteSeries: (occurrence: ICalendarOccurrence) => void
  onToggleCompleted: (occurrence: ICalendarOccurrence) => void
}

const formatDay = (value: string) =>
  new Date(`${value.substring(0, 10)}T00:00:00`).toLocaleDateString('tr-TR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

/** Takvimde tıklanan tekrarın detayı ve işlemleri */
export const EventDetailModal: FC<Props> = ({
  occurrence,
  interviewPath,
  onClose,
  onEdit,
  onDeleteOccurrence,
  onDeleteSeries,
  onToggleCompleted,
}) => {
  if (!occurrence) return null
  const recurring = occurrence.recurrenceType !== 'NONE'

  return (
    <Modal show={!!occurrence} onHide={onClose} dialogClassName='modal-dialog-centered'>
      <div className='modal-header'>
        <div className='d-flex align-items-center gap-3'>
          <span className='rounded-circle' style={{width: 14, height: 14, background: occurrence.color || '#009ef7'}} />
          <h5 className='modal-title'>{occurrence.title}</h5>
        </div>
        <button type='button' className='btn-close' onClick={onClose} />
      </div>
      <div className='modal-body'>
        <div className='d-flex flex-wrap gap-2 mb-5'>
          <span className='badge badge-light-primary'>{TYPE_LABEL[occurrence.type]}</span>
          {occurrence.shared && <span className='badge badge-light-info'>Firmayla paylaşılan</span>}
          {occurrence.type === 'TASK' && occurrence.completed && <span className='badge badge-success'>Tamamlandı</span>}
        </div>

        <div className='d-flex align-items-center gap-3 mb-3'>
          <i className='bi bi-clock fs-4 text-gray-500'></i>
          <span>
            {formatDay(occurrence.start)}
            {!occurrence.allDay && ` · ${formatTime(occurrence.start)} - ${formatTime(occurrence.end)}`}
            {occurrence.allDay && ' · Tüm gün'}
          </span>
        </div>
        {recurring && (
          <div className='d-flex align-items-center gap-3 mb-3'>
            <i className='bi bi-arrow-repeat fs-4 text-gray-500'></i>
            <span>{recurrenceSummary(occurrence)}</span>
          </div>
        )}
        {occurrence.meetLink && (
          <div className='d-flex align-items-center gap-3 mb-3'>
            <i className='bi bi-camera-video fs-4 text-gray-500'></i>
            <a href={occurrence.meetLink} target='_blank' rel='noopener noreferrer'>
              {occurrence.meetLink}
            </a>
          </div>
        )}
        {occurrence.ownerUserName && !occurrence.editable && (
          <div className='d-flex align-items-center gap-3 mb-3'>
            <i className='bi bi-person fs-4 text-gray-500'></i>
            <span>{occurrence.ownerUserName}</span>
          </div>
        )}
        {occurrence.description && (
          <div className='bg-light rounded p-4 mt-4' style={{whiteSpace: 'pre-line'}}>
            {occurrence.description}
          </div>
        )}
      </div>
      <div className='modal-footer justify-content-between'>
        <div className='d-flex gap-2'>
          {occurrence.type === 'INTERVIEW' && (
            <Link to={interviewPath} className='btn btn-sm btn-light-primary' onClick={onClose}>
              <i className='bi bi-people'></i>
              Mülakatlar
            </Link>
          )}
          {occurrence.editable && occurrence.type === 'TASK' && (
            <button
              type='button'
              className={`btn btn-sm ${occurrence.completed ? 'btn-light' : 'btn-success'}`}
              onClick={() => onToggleCompleted(occurrence)}
            >
              <i className={`bi ${occurrence.completed ? 'bi-arrow-counterclockwise' : 'bi-check2'}`}></i>
              {occurrence.completed ? 'Tamamlanmadı yap' : 'Tamamlandı'}
            </button>
          )}
        </div>
        {occurrence.editable && (
          <div className='d-flex flex-wrap gap-2'>
            <button type='button' className='btn btn-sm btn-light-primary' onClick={() => onEdit(occurrence)}>
              <i className='bi bi-pencil'></i>
              {recurring ? 'Seriyi düzenle' : 'Düzenle'}
            </button>
            {recurring && (
              <button type='button' className='btn btn-sm btn-light-danger' onClick={() => onDeleteOccurrence(occurrence)}>
                Bu tekrarı sil
              </button>
            )}
            <button type='button' className='btn btn-sm btn-danger' onClick={() => onDeleteSeries(occurrence)}>
              <i className='bi bi-trash'></i>
              {recurring ? 'Tümünü sil' : 'Sil'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}
